import { axiosInstance } from "services/axios";
import { SentryError } from "@stadium/services/error-reporting/utils";

import { camelizer } from "@stadium/helpers/formatter";

import {
  ORDER_SERVICE_API_URL,
  HUBSPOT_BOOK_A_CALL_PARTIAL_FORM_GUID,
} from "constants/env-variables";
import {
  buildHubspotFormSubmissionBody,
  HUBSPOT_CONTACT_OBJECT_TYPE_ID,
} from "@stadium/services/hubspot";
import { getHubspotSubmissionErrorResponse } from "@stadium/services/hubspot/api";
import { HUBSPOT_API_ENDPOINTS, HUBSPOT_PORTAL_ID } from "@stadium/services/hubspot/constants";

export const USERS_ENDPOINT = `${ORDER_SERVICE_API_URL}/users`;

const { post } = axiosInstance;

class BookACallError extends SentryError {
  get name() {
    return "Book a call API error";
  }
}

class HubspotFormDataSubmissionError extends SentryError {
  get name() {
    return "Hubspot form data submission error";
  }
}

export const bookACallApi = async (payload) => {
  try {
    return await post(`${USERS_ENDPOINT}/query`, payload).then((res) => {
      const responseData = camelizer(res);
      return responseData;
    });
  } catch (error) {
    throw new BookACallError(error);
  }
};

const buildHubspotFormRequestBody = ({ payload, pageName, hubspotContextRefactor }) => {
  if (!hubspotContextRefactor) {
    return { fields: payload };
  }

  const fields = payload.map((field) => ({
    objectTypeId: HUBSPOT_CONTACT_OBJECT_TYPE_ID,
    name: field.name,
    value: field.value == null ? "" : String(field.value),
  }));

  return buildHubspotFormSubmissionBody({ fields, pageName });
};

export const postHubspotFormData = async ({
  payload,
  portalId = HUBSPOT_PORTAL_ID,
  formGuid = HUBSPOT_BOOK_A_CALL_PARTIAL_FORM_GUID,
  /** Fallback when `document.title` is empty (SSR or edge cases). */
  pageName,
  hubspotContextRefactor = false,
}) => {
  const endpoint = HUBSPOT_API_ENDPOINTS.submitFormData
    .replace(":portalId", portalId)
    .replace(":formGuid", formGuid);

  const requestBody = buildHubspotFormRequestBody({
    payload,
    pageName,
    hubspotContextRefactor,
  });

  try {
    return await post(endpoint, requestBody);
  } catch (error) {
    throw new HubspotFormDataSubmissionError(error, {
      data: { payload, errorResponse: getHubspotSubmissionErrorResponse(error) },
    });
  }
};
